import { Children, cloneElement, useMemo, useRef } from 'react'
import { Col } from 'react-bootstrap'
import { useMediaQuery } from '@react-hookz/web'
import { clsx } from 'clsx'
import { isArray } from 'lodash-es'

import { PORTAL_BREAKPOINTS } from 'Constants/constants'

import { ContentSidebarProps } from './ContentSidebar.types'

export const ContentSidebar = (props: ContentSidebarProps) => {
  const { children, isColumnOpen, renderStickyColumnSideContent } = props

  const columnRef = useRef<HTMLDivElement>(null)

  const isDesktop = useMediaQuery(`(min-width: ${PORTAL_BREAKPOINTS.XXL})`)

  const renderChildren = useMemo(() => {
    if (!children) {
      return null
    }

    if (!isArray(children)) {
      return cloneElement(children, { columnRef })
    }

    return Children.map(children, child => cloneElement(child, { columnRef }))
  }, [children])

  return (
    <Col
      ref={columnRef}
      className="ContentSidebar position-relative"
      xl={12}
      xxl={4}
    >
      {renderStickyColumnSideContent && (
        <div className="d-none d-lg-block">
          <div className="position-absolute">
            <div className="ContentSidebar-scroll-area">
              {renderStickyColumnSideContent}
            </div>
          </div>
        </div>
      )}

      <div
        className={clsx(
          'ContentSidebar-preview-column',
          isDesktop && 'sticky-column',
          isColumnOpen
            ? 'sticky-column--preview'
            : 'ContentSidebar-preview-column--is-closed',
        )}
      >
        <div className="ContentSidebar-preview-column-wrapper">
          {renderChildren}
        </div>
      </div>
    </Col>
  )
}
